import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useGroupId } from './useGroupId';

interface LocationStateType {
    referrer?: string;
}

export function usePodDetailsNavigateBackFromSubRoute() {
    const navigate = useNavigate();
    const location = useLocation();
    const groupId = useGroupId();

    const handleNavigateBackFromSubRoute = useCallback(() => {
        if (!groupId) return;

        const locationState = location.state as LocationStateType;
        const referrer = locationState?.referrer;

        if (`/pods/${groupId}` === referrer) {
            navigate(-1);
        } else {
            navigate(`/pods/${groupId}`, { replace: true });
        }
    }, [groupId, location, navigate]);

    return {
        handleNavigateBackFromSubRoute,
    };
}
